import { render } from "./Empty.vue?vue&type=template&id=00ae5df8"
const script = {}

import "./Empty.vue?vue&type=style&index=0&id=00ae5df8&lang=scss"

import exportComponent from "/Users/yangxu/work/js_celue-zuhe_src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__